import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import type { ChallengeInfo } from "../api/getChallenge";

export function getDaysLeftText({ deadline }: ChallengeInfo): string {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const daysLeft = Math.abs(dayjs().diff(dayjs(deadline), "days")) + 1;
    return `${daysLeft} day${daysLeft === 1 ? "" : "s"}`;
}
